/**
 * Client-seitige Bild-Kompression + EXIF-Strip via Canvas.
 * Kein externes Lib nötig: `canvas.toBlob` strippt EXIF automatisch.
 *
 * Rückgabe: { blob, width, height, thumbBlob }
 */

async function readImage(file) {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = (e) => {
            URL.revokeObjectURL(url);
            reject(e);
        };
        img.src = url;
    });
}

function drawScaled(img, maxEdge) {
    let { width, height } = img;
    const long = Math.max(width, height);
    if (long > maxEdge) {
        const scale = maxEdge / long;
        width = Math.round(width * scale);
        height = Math.round(height * scale);
    }
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);
    return { canvas, width, height };
}

function canvasToBlob(canvas, type, quality) {
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (b) => (b ? resolve(b) : reject(new Error("Blob-Encoding fehlgeschlagen."))),
            type,
            quality
        );
    });
}

export async function processImage(file, { maxEdge = 2048, quality = 0.82, thumbEdge = 256 } = {}) {
    const img = await readImage(file);
    const main = drawScaled(img, maxEdge);
    const thumb = drawScaled(img, thumbEdge);
    const mainBlob = await canvasToBlob(main.canvas, "image/jpeg", quality);
    const thumbBlob = await canvasToBlob(thumb.canvas, "image/jpeg", 0.72);
    return {
        blob: mainBlob,
        thumb: thumbBlob,
        width: main.width,
        height: main.height,
        mime: "image/jpeg",
        ext: "jpg",
    };
}

export async function processBlob(blob, opts = {}) {
    // Input is a Blob (from canvas.toBlob e.g. from viewfinder capture).
    const file = new File([blob], "capture.jpg", { type: blob.type || "image/jpeg" });
    return processImage(file, opts);
}
